export default {"src":"/_next/static/media/startingPage.a930c8ee.svg","height":166,"width":280,"blurWidth":0,"blurHeight":0};